import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyBookByPhone, PropertyBookByPhoneSplitted } from '@shared-ui/lodging-property-details';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const BookByPhoneWrapper = ({
  inputs,
  className
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(PropertyBookByPhone, {
    inputs: inputs,
    className: className,
    skipSsr: cSRPropertyDetailsQuery
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(PropertyBookByPhoneSplitted, {
    inputs: inputs,
    className: className,
    skipSsr: cSRPropertyDetailsQuery
  })));
};
export const SharedUiBookByPhoneWrapper = withSharedUiPropertyDetails(BookByPhoneWrapper);
SharedUiBookByPhoneWrapper.displayName = 'SharedUiBookByPhoneWrapper';